import { render, staticRenderFns } from "./SuccessStep.vue?vue&type=template&id=83160c22&"
import script from "./SuccessStep.vue?vue&type=script&lang=js&"
export * from "./SuccessStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports